import clsx from 'clsx';
import { Tooltip } from '@inpart/ui-components';
import { parseISO, differenceInDays, format, isBefore } from 'date-fns';
import { getDaysLeftConfigFusion2 } from '../../util/getDaysLeft';

export type CampaignProgressBarProps = {
  openingDate?: string;
  closingDate?: string;
};

export const CampaignProgressBar: React.FC<CampaignProgressBarProps> = ({ openingDate, closingDate }) => {
  const closingDateISO = closingDate ? parseISO(closingDate) : null;
  const openingDateISO = openingDate ? parseISO(openingDate) : null;
  const isOpen = closingDateISO ? isBefore(new Date(), closingDateISO) : null;
  const daysLeftConfig = closingDateISO ? getDaysLeftConfigFusion2(isOpen ?? false, closingDateISO) : null;
  const formattedClosingDate = closingDateISO
    ? `${isOpen ? 'Closes' : 'Closed'}: ${format(closingDateISO, 'do MMM yyyy')}`
    : null;
  const percentageCampaignRunThrough =
    closingDateISO && openingDateISO
      ? (differenceInDays(new Date(), openingDateISO) / Math.max(1, differenceInDays(closingDateISO, openingDateISO))) *
        100
      : null;

  if (!daysLeftConfig) return null;

  return (
    <Tooltip label={formattedClosingDate || ''} ariaLabel={formattedClosingDate || ''}>
      <>
        <div className="text-body-md text-content-secondary flex-initial mb-0">{daysLeftConfig.text}</div>
        <div className="h-2 flex-1 rounded-full overflow-hidden bg-general-neutral-light relative min-w-0">
          <div
            className={clsx('h-2 absolute top-0 left-0', daysLeftConfig.variant)}
            style={{ width: `${percentageCampaignRunThrough ?? 0}%` }}
          />
        </div>
      </>
    </Tooltip>
  );
};
